import { useState } from 'react';
import fetch from 'node-fetch';
import config from '../../../../../../config';

let isFetching = false;
let storedData = [];
export const getCampaignTypes = ({ history }) => {
  const [data, setData] = useState(storedData);
  if (!isFetching) {
    isFetching = true;
    fetch(`${config.host}/campaign/campaign-types`, {credentials: 'include'})
      .then(res => res.json())
      .then(json => {
        if (json.status === 403) {
          history.push('/login');
        }
        if ('msg' in json) {
          storedData = json.msg.map(item => ({
            value: item.id,
            label: item.campaign_type,
            description: item.description,
          }));
          setData(storedData);
        }
      });
  }
  return data;
};

export default getCampaignTypes;

